/*========================================================================
 * $Id: tabs.js 88584 2016-02-03 12:46:52Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
	"client/application",
	"model/persisted_collection",
	"api/v2/persisted",
	"service/stub",
	"underscore",
	"backbone",
	"utils/jsonpath"
	], function (
		Application,
    PersistedCollection,
		Persisted,
		Stub,
		_,
		Backbone,
		JSONPath
	) {

  var originalGetModel = Application.prototype.getModel;
	Application.prototype.getModel = function (name) {
		if (/^persistedresources:/.test(name)) {
			return this.getPersistedResourcesCollectionModel(name.substring(19).split("/"))
		}
		return originalGetModel.apply(this, arguments);
	};

  var DataEncodingPersistedResourceModel = PersistedCollection.Model.extend({
      
    parse: function (atts) {
      // console.log("parse");
      var result = _.extend({}, atts);
      var props = {};
      if (_.isArray(atts && atts.property)) {
        props.properties = _.reduce(atts.property, function(properties, p) {
          properties[p.key] = p.value;
          return properties;
        }, {});
        delete result.property;
      }
      if ((!atts || !atts.id) && (atts && atts.path)) {
        props.id = atts.path.join("/");
      }
      if (result && result.data) {
        result.data = JSON.parse(decodeURIComponent(atts.data))
      }

      return _.extend({}, result, props);
    },

    toJSON: function(options) {
      // console.log("toJSON");
      var atts = _.clone(this.attributes);
      if (atts.properties && _.isObject(atts.properties)) {
        var result = [];
        var keys = _.keys(atts.properties);
        for (var i = 0; i < keys.length; ++i) {
          result.push({key: keys[i], value: atts.properties[keys[i]]});
        }
        atts.property = result;
        delete atts.properties;
      }
      if (atts.data) {
        atts.data = encodeURIComponent(JSON.stringify(atts.data))
      }
      return atts;
    },

    get: function (key) {
      return JSONPath.evalPath(key, this.attributes);
    }
  });

	Application.prototype.getPersistedResourcesCollectionModel = function (path) {
		var modelId = "persistedresources:" + path.join("/");
		var collection = this.models[modelId];
		if (collection) return collection;

    var persisted = new Persisted({
        channels: this.models.defaultChannels,
        model: DataEncodingPersistedResourceModel
    });
    var collection = persisted.resources(path);
		collection.fetch({ path: path });
		this.models[modelId] = collection;

		return collection;
	};

});
